const STYLE_CONSTANTS = {
  FONT_FAMILY: 'Montserrat, sans-serif',
  FONT_WEIGHT_REGULAR: 400,
  FONT_WEIGHT_BOLD: 600,
}

export default STYLE_CONSTANTS
